import React from "react";
import { ModalConsumer } from "../../providers/Modal";

import "./Modal.scss";

export default function Modal() {
  return (
    <ModalConsumer>
      {({ modalIsOpen, closeModal, openModal, content }) => (
        <div
          style={{ display: modalIsOpen ? "flex" : "none" }}
          className="modal-component"
          onClick={closeModal}
        >
          <div className="modal-container" onClick={(e) => e.stopPropagation() }>
            {content}
            </div>
        </div>
      )}
    </ModalConsumer>
  );
}
